/*
 * Location request disabled for page speed / Lighthouse Best Practices.
 * The previous version asked every visitor for their location on page load
 * and the result was never used anywhere on the site.
 * If delivery checks are added later, call navigator.geolocation only
 * when the visitor clicks a button (e.g. "Check delivery").
 *
 * This file is loaded on every page (end of layout/theme.liquid), so it also
 * holds a small accessibility fix: app widgets such as the Google & YouTube
 * app's merchant widget inject an <iframe> without a title. Screen readers
 * need one, so give any untitled iframe a title as soon as it appears.
 */
(function () {
  'use strict';

  function titleFor(frame) {
    var src = frame.getAttribute('src') || '';
    if (frame.id === 'merchantwidgetiframe' || src.indexOf('google.com/shopping') !== -1) {
      return 'Google merchant widget';
    }
    if (src.indexOf('youtube') !== -1) return 'YouTube video';
    return 'Embedded content';
  }

  function fixFrames() {
    var frames = document.querySelectorAll('iframe:not([title])');
    for (var i = 0; i < frames.length; i++) {
      frames[i].setAttribute('title', titleFor(frames[i]));
    }
  }

  fixFrames();
  if (!('MutationObserver' in window)) return;
  var observer = new MutationObserver(fixFrames);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  // Widgets are injected shortly after load; stop watching after a minute.
  setTimeout(function () { observer.disconnect(); }, 60000);
})();
